<template>
  <div class="row form-container justify-content-center">
    <div class="col-12 col-md-10 col-lg-10 col-xl-10">
      <div class="row justify-content-center" style="">
        <div class="col-12 col-md-10 col-lg-8 col-xl-8">
          <div class="tit text-center">
            <img src="/static/assets/images/ico-smile.svg" alt="Icone feliz">
            <h1>O 1º passo para você fazer parte da IOUU foi concluído com sucesso! </h1>
            <p>O próximo passo é completar o <b>cadastro de investidor</b>, preencher o formulário de suitability e aguardar o processo de análise e aprovação para  começar a investir nas oportunidades da plataforma.</p>
          </div>

          <div class="text-center suitability-link-container">
            <router-link to="/informacoes-adicionais/investidor" class="btn btn-sm btn-primary" title="Preencher formulário investidor">Entendi, quero completar meu cadastro</router-link>
          </div>

           <div class="text-center suitability-link-container">
            <router-link to="/investimentos/oportunidades/" class="btn btn-sm btn-primary" title="Preencher formulário investidor">Primeiro, quero ver as oportunidades</router-link>
          </div>
         
          <div class="text-center">
            <a href="/" class="link logo" title="IOUU">
              <i class="ico-iouu" />
            </a>
            <p class="obs">Juntos vamos reinventar o sistema bancário ultrapassado e garantir um melhor negócio para todos.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../assets/styles/iouu/variables";
  @import "../assets/styles/iouu/mixins";

  div > {
    i {
      margin-top: 50px;
      font-size: 100px;
      line-height: 60px;
      color: $c3;
    }
  }
  .tit {
    img {
      width: 80px;
      margin-bottom: 40px
    }
  }

  .suitability-link-container {
    margin: 5vh 0;
  }

  @include xs {
    .steps {
      .btn-primary {
        width: 100%;
        padding: 14px 0;
        font-size: calcRem(13);
      }
    }
  }

  .link {
    &.logo{
      font-size: 60px;
      color: #70DECD;
    }
  }
</style>


<script>

  export default {
    data() {
      return {
        transitionName: 'slide-left',
        investor: null
      }
    },

    methods: {
      //tagueamento GA
      taggingGA() {
        this.$ga.page({
          page: '/cadastrar-senha',
          title: 'CadastrarSenha',
        })
      },
    },

    async created() {
      //tagueamento GA
      await this.taggingGA();
    }
   
  }
</script>



// WEBPACK FOOTER //
// src/views/ConfirmCadastroInvestor.vue